import React from 'react';
import { ArrowRight, ArrowDown } from 'lucide-react';
const rows = [{
  label: 'Planificación',
  before: 'Noches de domingo buscando ideas que no terminan de cerrar.',
  after: '−90% tiempo. Sesiones listas en tu tablet en solo 2 clics.'
}, {
  label: 'Seguridad',
  before: 'Inseguridad al dar clases a personas con lesiones de columna.',
  after: 'Confianza total. Bloques clínicos seguros y específicos.'
}, {
  label: 'Variedad',
  before: 'Clases mecánicas que aburren a tus alumnas más antiguas.',
  after: '+100% originalidad. Progresiones lógicas que desafían y motivan.'
}, {
  label: 'Energía',
  before: 'Llegas a tu estudio mentalmente cansada de organizar todo.',
  after: 'Cero estrés. Llegas vibrante para conectar con tus alumnas.'
}];
const bottomStats = [{
  num: '+150h',
  label: 'Ahorradas al año'
}, {
  num: '2 clics',
  label: 'Para cada clase lista'
}, {
  num: '100%',
  label: 'Profesional'
}];
export function ContrastSection() {
  return <section className="w-full bg-bg-main py-20 px-4" data-id="element-102">
      <div className="max-w-4xl mx-auto" data-id="element-103">
        {/* Section header */}
        <div className="text-center mb-12" data-id="element-104">
          <p className="text-primary font-bold uppercase tracking-wider text-xs sm:text-sm mb-3" data-id="element-105">
            ⚡ La transformación
          </p>
          <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-4 tracking-tight" data-id="element-106">
            De una instructora agotada a una{' '}
            <span className="text-primary" data-id="element-107">profesional inspirada</span>.
          </h2>
          <p className="text-text-sec text-base sm:text-lg max-w-2xl mx-auto" data-id="element-108">
            Esto es lo que cambia desde la primera semana con Megapack Pilates
            Listo en tus manos.
          </p>
        </div>

        {/* Time cost callout */}
        <div className="bg-badge-red/10 border border-badge-red/20 rounded-2xl p-6 sm:p-8 mb-12 text-center" data-id="element-109">
          <p className="text-badge-red font-black text-2xl sm:text-3xl mb-2" data-id="element-110">
            150+ horas / año
          </p>
          <p className="text-text-main text-base sm:text-lg font-medium leading-relaxed" data-id="element-111">
            <span className="text-badge-red font-bold" data-id="element-112">El costo real:</span>{' '}
            Planificar manualmente te quita de 3 a 5 horas por semana. Es el
            equivalente a un{' '}
            <span className="text-badge-red font-black" data-id="element-113">
              mes entero de trabajo al año
            </span>{' '}
            quemado en cuadernos, dibujos y dudas mentales.
          </p>
        </div>

        {/* Comparison stack — each row is its own card for max readability */}
        <div className="space-y-5 sm:space-y-6 mb-10" data-id="element-114">
          {rows.map((row, i) => <div key={i} className="bg-bg-alt rounded-2xl border border-border-light overflow-hidden shadow-[0_4px_20px_-8px_rgba(90,70,120,0.12)] hover:shadow-[0_8px_28px_-10px_rgba(139,111,191,0.22)] transition-shadow duration-300" data-id="element-115">
              {/* Category chip */}
              <div className="px-5 sm:px-6 pt-4 sm:pt-5 pb-3 flex items-center gap-2" data-id="element-116">
                <span className="inline-flex items-center gap-1.5 bg-primary/10 text-primary font-black text-[11px] sm:text-xs uppercase tracking-widest px-3 py-1 rounded-full border border-primary/20" data-id="element-117">
                  {row.label}
                </span>
                <span className="text-text-sec text-[10px] sm:text-xs font-medium" data-id="element-118">
                  {i + 1} / {rows.length}
                </span>
              </div>

              {/* Before → After */}
              <div className="grid grid-cols-1 md:grid-cols-[1fr_auto_1fr] items-stretch" data-id="element-119">
                {/* BEFORE — desaturated, faded */}
                <div className="px-5 sm:px-6 py-5 sm:py-6 flex items-start gap-3 sm:gap-4 bg-badge-red/[0.04] border-t border-border-light md:border-t-0" data-id="element-120">
                  <div className="w-7 h-7 rounded-full bg-badge-red/15 flex items-center justify-center flex-shrink-0 mt-0.5 border border-badge-red/25" data-id="element-121">
                    <span className="text-badge-red font-bold text-xs" data-id="element-122">✕</span>
                  </div>
                  <div data-id="element-123">
                    <p className="text-badge-red font-bold text-[10px] sm:text-xs uppercase tracking-wider mb-1" data-id="element-124">
                      Antes
                    </p>
                    <p className="text-text-sec font-medium text-[15px] sm:text-base leading-snug" data-id="element-125">
                      {row.before}
                    </p>
                  </div>
                </div>

                {/* Arrow connector — desktop horizontal, mobile vertical */}
                <div className="flex items-center justify-center py-1 md:px-2 md:py-0 md:border-x border-border-light bg-bg-main/40" data-id="element-126">
                  <div className="w-9 h-9 rounded-full bg-primary text-white flex items-center justify-center shadow-[0_4px_12px_-2px_rgba(139,111,191,0.5)]" data-id="element-127">
                    <ArrowRight className="w-4 h-4 hidden md:block" data-id="element-128" />
                    <ArrowDown className="w-4 h-4 md:hidden" data-id="element-129" />
                  </div>
                </div>

                {/* AFTER — vibrant, dimensional */}
                <div className="px-5 sm:px-6 py-5 sm:py-6 flex items-start gap-3 sm:gap-4 bg-gradient-to-br from-primary/[0.08] via-primary/[0.05] to-cta-green/[0.06] relative overflow-hidden" data-id="element-130">
                  <div className="w-7 h-7 rounded-full bg-cta-green flex items-center justify-center flex-shrink-0 mt-0.5 shadow-[0_4px_10px_-2px_rgba(15,139,111,0.5)]" data-id="element-131">
                    <span className="text-white font-bold text-xs" data-id="element-132">✓</span>
                  </div>
                  <div className="relative z-10" data-id="element-133">
                    <p className="text-cta-green font-bold text-[10px] sm:text-xs uppercase tracking-wider mb-1" data-id="element-134">
                      Ahora
                    </p>
                    <p className="text-text-main font-bold text-[15px] sm:text-base leading-snug" data-id="element-135">
                      {row.after}
                    </p>
                  </div>
                </div>
              </div>
            </div>)}
        </div>

        {/* Inline reinforcement CTA */}
        <div className="text-center mb-10 sm:mb-12" data-id="element-136">
          <a href="#pricing" className="inline-flex items-center gap-2 text-cta-green font-bold text-sm sm:text-base hover:gap-3 transition-all border-b-2 border-cta-green/30 hover:border-cta-green pb-0.5" data-id="element-137">
            Quiero esta transformación
            <ArrowRight className="w-4 h-4" data-id="element-138" />
          </a>
        </div>

        {/* Bottom stats */}
        <div className="grid grid-cols-3 gap-3 sm:gap-6" data-id="element-139">
          {bottomStats.map((s, i) => <div key={i} className="bg-bg-alt border border-primary/20 rounded-xl p-4 sm:p-6 text-center" data-id="element-140">
              <p className="text-primary font-black text-xl sm:text-3xl mb-1" data-id="element-141">
                {s.num}
              </p>
              <p className="text-text-sec text-xs sm:text-sm leading-snug" data-id="element-142">
                {s.label}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}